import { Pipe, PipeTransform } from '@angular/core';
import { GradeLevel } from '@models/grade-level';

@Pipe({ name: 'gradeLevel' })
export class GradeLevelPipe implements PipeTransform {
  transform(value: GradeLevel): string {
    switch (value) {
      case GradeLevel.TRANSITIONAL_KINDERGARTEN:
        return 'Transitional Kindergarten';
      case GradeLevel.KINDERGARTEN:
        return 'Kindergarten';
      case GradeLevel.FIRST:
        return 'Grade 1';
      case GradeLevel.SECOND:
        return 'Grade 2';
      case GradeLevel.THIRD:
        return 'Grade 3';
      case GradeLevel.FOURTH:
        return 'Grade 4';
      case GradeLevel.FIFTH:
        return 'Grade 5';
      case GradeLevel.SIXTH:
        return 'Grade 6';
      default:
        return '';
    }
  }
}
